import { EMPTY_VALUE, FieldSchema, FieldValues } from "../../../Schema";

export const secondaryID: FieldSchema = {
  name: "secondaryID",
  data: {
    assignedValue: {
      getter: (values) => {
        if (values.secondaryIDMapping) {
          return (values.secondaryIDMapping as string)
            .split("; ")
            .map((field: keyof FieldValues) => (values[field] ?? EMPTY_VALUE))
            .join(" - ") ?? EMPTY_VALUE;
        }
        return null;
      },
      fields: ["secondaryIDMapping", "equipmentId", "serialNumber", "manufacturer", "equipmentModel"],
    },
  },
  form: { label: "Secondary ID", disabled: true, displayed: false },
};
